export default __webpack_public_path__ + "static/media/Algoma University.0b44a24d.png";